import React from 'react';
import { Typography, Flex } from 'antd';
import Icon from '@mdi/react';
import { mdiPencil } from '@mdi/js';
import { useWidget } from 'components/Widget/useWidget';

const EditWidgetTitle = ({}) => {
  const { titleConfig, editableStr, setEditableStr } = useWidget();
  const { Paragraph } = Typography;

  return (
    <Flex align='center' gap='small' className='font-semibold text-md ml-2 h-12'>
      <span className='w-fit whitespace-nowrap'>{titleConfig}</span>
      <Paragraph
        size='small'
        className='font-semibold flex items-center !ml-2 h-fit !mb-0 !mt-0 w-full'
        editable={{
          className: 'mt-2 mx-4',
          icon: <Icon path={mdiPencil} className='!text-orange !cursor-pointer flex' />,
          tooltip: 'Edit Title',
          onChange: (val) => setEditableStr(val),
          type: 'text',
        }}
      >
        {editableStr}
      </Paragraph>
    </Flex>
  );
};

export default EditWidgetTitle;
